/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ImageExample .ms-Image{border:2px solid "},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";margin-bottom:20px}"}]);
/* tslint:enable */